import { FETCH_SECTORS } from 'actions/sectors';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_SECTORS:
			return action.payload;
		default:
			return state;
	}
};